import { WORKY_WEB_APP_PATHS } from '../WorkyWebAppPaths';
import { getAuthFlow, isValidString, setAuthFlow } from '../common/CommonUtilsMethods';
import { ensureAuthClientConfigLoaded } from './WorkyAuthClientConfigService';
import { AUTH_FLOW_TYPE } from './WorkyAuthClientConfigInterfaces';

const hostedSignInUrl: string = process.env.REACT_APP_IDP_SIGN_IN_URL ?? '';
const hostedSignUpUrl: string = process.env.REACT_APP_IDP_SIGN_UP_URL ?? '';

const buildSignupPathWithQuery = (primaryWorkyCorpId?: string): string => {
    if (!isValidString(primaryWorkyCorpId)) {
        return WORKY_WEB_APP_PATHS.signup;
    }
    const encodedPrimaryWorkyCorpId: string = encodeURIComponent(primaryWorkyCorpId.trim());
    return `${WORKY_WEB_APP_PATHS.signup}?primaryWorkyCorpId=${encodedPrimaryWorkyCorpId}`;
};

const navigateToHostedSignIn = (): void => {
    setAuthFlow(AUTH_FLOW_TYPE.HOSTED);
    if (isValidString(hostedSignInUrl)) {
        window.location.assign(hostedSignInUrl);
    }
};

const navigateToHostedSignUp = (): void => {
    setAuthFlow(AUTH_FLOW_TYPE.HOSTED);
    if (isValidString(hostedSignUpUrl)) {
        window.location.assign(hostedSignUpUrl);
    }
};

const navigateToCustomSignIn = (): void => {
    setAuthFlow(AUTH_FLOW_TYPE.CUSTOM);
    window.location.assign(WORKY_WEB_APP_PATHS.login);
};

const navigateToCustomSignUp = (primaryWorkyCorpId?: string): void => {
    setAuthFlow(AUTH_FLOW_TYPE.CUSTOM);
    window.location.assign(buildSignupPathWithQuery(primaryWorkyCorpId));
};

const navigateToLogin = async (): Promise<void> => {
    const useCustomAuthUi: boolean = await ensureAuthClientConfigLoaded();
    if (useCustomAuthUi) {
        navigateToCustomSignIn();
        return;
    }
    navigateToHostedSignIn();
};

const navigateToSignUp = async (primaryWorkyCorpId?: string): Promise<void> => {
    const useCustomAuthUi: boolean = await ensureAuthClientConfigLoaded();
    if (useCustomAuthUi) {
        navigateToCustomSignUp(primaryWorkyCorpId);
        return;
    }
    navigateToHostedSignUp();
};

/**
 * Used when an existing session expires. Prefer the flow the user originally signed in with.
 */
const redirectToLogin = async (): Promise<void> => {
    const storedAuthFlow: string | null = getAuthFlow();
    if (storedAuthFlow === AUTH_FLOW_TYPE.CUSTOM) {
        navigateToCustomSignIn();
        return;
    }
    await navigateToLogin();
};

export {
    navigateToLogin,
    navigateToSignUp,
    redirectToLogin,
    navigateToCustomSignIn,
    navigateToHostedSignIn,
};
